import script from "./CouponsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponsView.vue?vue&type=script&setup=true&lang=js"

import "./CouponsView.vue?vue&type=style&index=0&id=5c6c32dc&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c6c32dc"]])

export default __exports__